import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withKeys as _withKeys, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a5c269a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "msg_composer",
  class: "foregr onBottom",
  ref: "msgComposer"
}
const _hoisted_2 = { class: "text_bar" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 0 24 24",
  width: "24px",
  fill: "#FFFFFF"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" })
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 0,
  class: "custom_keyboard"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 1,
  id: "msg_composer",
  class: "foregr onBottom",
  ref: "msgComposer"
}
const _hoisted_8 = {
  key: 0,
  class: "custom_keyboard"
}
const _hoisted_9 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HintButton = _resolveComponent("HintButton")!

  return (
      !_ctx.showCustomKeyboard ||
      _ctx.customKeyboard ||
      _ctx.options == null ||
      _ctx.options.length === 0
    )
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_HintButton),
          _createElementVNode("div", {
            onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateMsg && _ctx.updateMsg(...args))),
            "data-ph": "Scrivi messaggio",
            id: "send-msg",
            contenteditable: "true",
            onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.sendMessage(_ctx.msg)), ["enter"]))
          }, _toDisplayString(_ctx.msg), 33),
          _createElementVNode("div", {
            id: "send-btn",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sendMessage(_ctx.msg)))
          }, _hoisted_4)
        ]),
        (_ctx.customKeyboard && _ctx.showCustomKeyboard)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (row) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: row,
                  ref: "customKeyboard_row",
                  class: "customK_row"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (opt) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: opt,
                      ref: "customKeyboard_btn",
                      class: "customK_btn",
                      onClick: ($event: any) => (this.msg += opt)
                    }, _toDisplayString(opt), 9, _hoisted_6))
                  }), 128))
                ], 512))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ], 512))
    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
        (_ctx.showCustomKeyboard)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (row) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: row,
                  ref: "customKeyboard_row",
                  class: "customK_row"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (opt) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: opt,
                      ref: "customKeyboard_btn",
                      class: "customK_btn",
                      onClick: ($event: any) => (_ctx.sendMessage(opt))
                    }, _toDisplayString(opt), 9, _hoisted_9))
                  }), 128))
                ], 512))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ], 512))
}